"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserAssociatedTokenAccountsWithNativeSOLOverride = exports.useUserAssociatedTokenAccounts = void 0;
const sail_1 = require("@saberhq/sail");
const token_utils_1 = require("@saberhq/token-utils");
const use_solana_1 = require("@saberhq/use-solana");
const react_1 = require("react");
const sdk_1 = require("./sdk");
const useQuarryProgramAddresses_1 = require("./useQuarryProgramAddresses");
const useUserAssociatedTokenAccounts = (tokens) => {
    const wallet = (0, use_solana_1.useConnectedWallet)();
    const owner = wallet === null || wallet === void 0 ? void 0 : wallet.publicKey;
    const memoTokens = (0, react_1.useMemo)(() => tokens, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(tokens.map((tok) => tok === null || tok === void 0 ? void 0 : tok.mintAccount.toString()))]);
    const programAddresses = (0, react_1.useMemo)(() => getQuarryATAs(memoTokens, owner), [memoTokens, owner]);
    const userTokenAccountKeys = (0, useQuarryProgramAddresses_1.useQuarryProgramAddresses)(programAddresses);
    const accountsData = (0, sail_1.useParsedAccountsData)(userTokenAccountKeys, sail_1.TOKEN_ACCOUNT_PARSER);
    return (0, react_1.useMemo)(() => parseTokenAccountsInternal({
        accountsData,
        memoTokens,
        userTokenAccountKeys,
    }), [accountsData, memoTokens, userTokenAccountKeys]);
};
exports.useUserAssociatedTokenAccounts = useUserAssociatedTokenAccounts;
const useUserAssociatedTokenAccountsWithNativeSOLOverride = (tokens) => {
    const { nativeBalance } = (0, sdk_1.useQuarrySDK)();
    const wallet = (0, use_solana_1.useConnectedWallet)();
    const owner = wallet === null || wallet === void 0 ? void 0 : wallet.publicKey;
    const memoTokens = (0, react_1.useMemo)(() => tokens, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(tokens.map((tok) => tok === null || tok === void 0 ? void 0 : tok.mintAccount.toString()))]);
    const programAddresses = (0, react_1.useMemo)(() => getQuarryATAs(memoTokens, owner), [memoTokens, owner]);
    const userTokenAccountKeys = (0, useQuarryProgramAddresses_1.useQuarryProgramAddresses)(programAddresses);
    const accountsData = (0, sail_1.useParsedAccountsData)(userTokenAccountKeys, sail_1.TOKEN_ACCOUNT_PARSER);
    return (0, react_1.useMemo)(() => parseTokenAccountsInternal({
        accountsData,
        memoTokens,
        userTokenAccountKeys,
        nativeBalance,
    }), [accountsData, memoTokens, nativeBalance, userTokenAccountKeys]);
};
exports.useUserAssociatedTokenAccountsWithNativeSOLOverride = useUserAssociatedTokenAccountsWithNativeSOLOverride;
const getQuarryATAs = (memoTokens, owner) => {
    if (!owner) {
        return [null];
    }
    return memoTokens.map((t) => t
        ? {
            type: useQuarryProgramAddresses_1.QuarryPDA.ATA,
            path: [t.mintAccount, owner],
        }
        : null);
};
const parseTokenAccountsInternal = ({ accountsData, memoTokens, userTokenAccountKeys, nativeBalance = null, }) => {
    return accountsData.map((datum, i) => {
        var _a;
        const userTokenAccountKey = userTokenAccountKeys[i];
        if (!userTokenAccountKey) {
            return undefined;
        }
        const token = memoTokens[i];
        if (!token) {
            return undefined;
        }
        const parsed = datum ? datum.accountInfo.data : datum;
        if (nativeBalance && token.mintAccount.equals(token_utils_1.NATIVE_MINT)) {
            return {
                key: userTokenAccountKey,
                loading: false,
                balance: nativeBalance,
                isInitialized: !!datum,
            };
        }
        try {
            return {
                key: userTokenAccountKey,
                loading: datum === undefined,
                balance: parsed
                    ? new token_utils_1.TokenAmount(token, parsed.amount)
                    : new token_utils_1.TokenAmount(token, 0),
                isInitialized: !!datum,
            };
        }
        catch (e) {
            console.warn(`Error parsing ATA ${(_a = datum === null || datum === void 0 ? void 0 : datum.accountId.toString()) !== null && _a !== void 0 ? _a : "(unknown)"}`, e);
            return undefined;
        }
    });
};
//# sourceMappingURL=useUserAssociatedTokenAccounts.js.map